import { TextField, TextFieldProps, InputAdornment } from '@mui/material'
import { forwardRef } from 'react'

export interface InputProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'outlined' | 'filled' | 'standard'
  error?: boolean
  helperText?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  loading?: boolean
}

const Input = forwardRef<HTMLDivElement, InputProps>(({
  variant = 'outlined',
  error = false,
  helperText,
  startIcon,
  endIcon,
  loading = false,
  ...props
}, ref) => {
  return (
    <TextField
      ref={ref}
      variant={variant}
      error={error}
      helperText={helperText}
      fullWidth
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">
            {startIcon}
          </InputAdornment>
        ) : undefined,
        endAdornment: endIcon ? (
          <InputAdornment position="end">
            {endIcon}
          </InputAdornment>
        ) : undefined,
        ...props.InputProps,
      }}
      {...props}
    />
  )
})

Input.displayName = 'Input'

export default Input
